/* unplugin-vue-components disabled */import script from "./CorporateInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./CorporateInformation.vue?vue&type=script&setup=true&lang=ts"

import "./CorporateInformation.vue?vue&type=style&index=0&id=37571bec&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37571bec"]])

export default __exports__